<template>
  <table class="table">
    <thead>
      <tr>
        <th>Uhrzeit</th>
        <th>Type</th>
        <th>Bereich</th>
        <th>Meldung</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="m in messages" :key="m.id" v-bind:class="{ error: m.level == 'ERROR', info: m.level == 'INFO', warning: m.level == 'WARN' }">
        <td>{{ m.time }}</td>
        <td>{{ m.level }}</td>
        <td>{{ m.logger }}</td>
        <td>{{ m.msg }}</td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped>
  tr.error {
    background-color: #C88;
    color: #222;
  }
  tr.info {
    background-color: #8C8;
    color: #222;
  }
  tr.warning {
    background-color: #CC8;
    color: #222;
  }
</style>

<script>
//import config from '@/modules/config.js'

export default {
  name: 'LiveLogView',
  data() {
    return {
      socket: false,
      messages: [],
      idc: 0,
    }
  },
  mounted: function() {
    //var self = this;
    this.socket = new WebSocket('ws://10.206.114.239:8080/logstream');
    this.socket.onmessage = this.addEvent.bind(this);

    console.log('chec log stream');
  },
  beforeDestroy: function() {
    if (this.socket) {
      this.socket.close();
      console.log('log socket closed');
    }
  },
  methods: {
    addEvent(e) {
      if (e.data && e.data.startsWith('event: log')) {
        var log = JSON.parse(e.data.substring('event: log\ndata: '.length));
        console.log(log);
        log.id = this.idc++;
        this.messages.unshift(log);
        if (this.messages.length > 800) {
          this.messages.length = 800;
        }
      }
    }
  }
}
</script>
